/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/networks.actions'
import * as ActionTypes from '@src/redux/actionTypes/networks.action.types'
import { defaultState, NetworksState } from './default.state'

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): NetworksState {
  switch (action.type) {
    case ActionTypes.GET_NETWORKING_SUCCESS: {
      const {
        instanceInfoList,
        sgInfoList,
        subnetInfoList,
        sgRulesInfoList,
        routesInfoList
      } = action.payload
      return {
        ...state,
        instanceInfoList,
        sgInfoList,
        subnetInfoList,
        sgRulesInfoList,
        routesInfoList
      }
    }
    default: {
      return state
    }
  }
}
